import React  from 'react';
import moment from 'moment-timezone';
import TextField from './TextField';

export default function DateCreated(props) {
  const { project } = props;

  return (
    <TextField label="Date Created">
      {moment(project.data.createdAt).format('MMM D, YYYY')} · {`${moment().diff(project.data.createdAt, 'days')} days ago`}
    </TextField>
  );
}
